export class ContactAPI {
    constructor() {
        this.endpoint =
            "https://vo2-construction-function.azurewebsites.net/api/send";
        this.clientSecret = "x!#XDFGX__s2!";
    }

    async send(email, message, name = undefined, subject = undefined) {
        const body = {
            email,
            message,
            source: "vo2-web",
        };
        if (name) {
            body["full_name"] = name;
        }
        if (subject) {
            body["subject"] = subject;
        }

        const headers = new Headers();
        headers.append("Client-Request-Secret", this.clientSecret);

        const options = {
            method: "POST",
            headers: headers,
            body: JSON.stringify(body),
        };

        const response = await fetch(this.endpoint, options);
        const status = response.status;
        let data = await response.json();
        return [status, data];
    }
}
